export default [
    {
      path: '/login',
      name: 'login',
      meta: { requiresGuest: true },
      component: () =>
      import(/* webpackChunkName: "login" */ '@/pages/Login.vue')
    }
  ]
  